/**
 * Phase 83-05 (PRREC-03) — fleet-wide printer-offline badge in Topbar.
 *
 * NON-BLOCKING telemetry (PRREC-03 LOCK + PRREC-05): renders nothing when zero
 * kiosks have an offline (EXPECTED) printer; otherwise an amber badge with a
 * printer icon + count. NEVER a modal — this only surfaces the count.
 *
 * Backed by the machines query (derived subset where `printer_offline === true`
 * via usePrinterOfflineKiosks). The backend sets/clears the flag from the
 * kiosk's printer_offline alarm and broadcasts it over /ws/v1/fleet, so the
 * count flips on/off live (useFleetWebSocket merges the field into the cache).
 *
 * Mirrors StaleBadge (Phase 67-01 D-04 touchpoint 1).
 */

import { Printer } from "lucide-react";
import { useTranslation } from "react-i18next";

import { usePrinterOfflineKiosks } from "@/hooks/queries/usePrinterOfflineKiosks";

export default function PrinterOfflineBadge() {
  const { t } = useTranslation();
  const { data, isLoading } = usePrinterOfflineKiosks();
  if (isLoading || !data || data.length === 0) return null;

  const count = data.length;
  return (
    <div
      data-testid="printer-offline-badge"
      className="flex items-center gap-1 px-2 py-1 rounded-md
                 bg-amber-100 text-amber-900 dark:bg-amber-900/30
                 dark:text-amber-200 text-xs font-medium"
      title={t("dashboard.printerOffline.title", { count })}
    >
      <Printer className="w-3.5 h-3.5" />
      <span>{t("dashboard.printerOffline.badge", { count })}</span>
    </div>
  );
}
